import { ExtensionValidator } from "../services/files/ExtensionValidator";

export const validateFileExtension = (file: File, supportedExtensions: string[]): boolean => {
  return ExtensionValidator.isSupported(file, supportedExtensions);
};

export const validateFileSize = (file: File, allowedFileMaxsize: number): boolean => {
  const { size } = file;
  return size < allowedFileMaxsize;
};
